import React, { useState } from 'react';
import { StyledTeaser, Figure, Image, TextWrapper, Timestamp, Title, Text } from './styles.RelatedContent';

interface Props {
    title?: string;
    text?: string;
    timestamp?: string;
    href?: string;
    img?: string;
    alt?: string;
}

export const Teaser: React.FC<Props> = ({ title, text, timestamp, href, img, alt }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <StyledTeaser
            href={href}
            target="_blank"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Figure>
                <Image src={img} alt={alt} isZoomed={isHovered} />
            </Figure>
            <TextWrapper>
                <Timestamp>{timestamp}</Timestamp>
                <Title>{title}</Title>
                <Text>{text}</Text>
            </TextWrapper>
        </StyledTeaser>
    );
};
